// src/components/PropertyFormSections/PhotoUpload.js
import React from 'react';

const PhotoUpload = ({ photo, handlePhotoChange }) => {
    return (
        <div className="mb-4">
            <label className="block font-bold">Property Photo</label>
            <input
                type="file"
                accept="image/*"
                onChange={handlePhotoChange}
                className="border p-2 w-full"
            />
            {photo && (
                <img
                    src={URL.createObjectURL(photo)}
                    alt="Preview"
                    className="w-full h-40 object-cover mt-2 rounded"
                />
            )}
        </div>
    );
};

export default PhotoUpload;